import { defineMessages } from "react-intl";

export const texts = defineMessages({
  ofText: {
    defaultMessage: "of",
    id: "C9WGEu",
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "47FYwb",
  },
  add: {
    defaultMessage: "Add Item",
    id: "kNLPWW",
  },
  update: {
    defaultMessage: "Update",
    id: "BWpuKl",
  },
  deleteItem: {
    defaultMessage: "Delete Item",
    id: "xyK+T/",
  },
  addNewValue: {
    defaultMessage: "Add New Value",
    id: "yJLIW7",
  },
  notModifiableTooltip: {
    defaultMessage: "You are not able to edit this checklist item.",
    id: "YNCxSd",
  },
  cantDeleteTooltip: {
    defaultMessage: "You can't delete this item",
    id: "lYfXIE",
  },
  dueDate: {
    defaultMessage: "Due Date",
    id: "8XUukm",
  },
  selectToday: {
    defaultMessage: "Select Today",
    id: "FFn/d6",
  },
  clearDate: {
    defaultMessage: "Clear Date",
    id: "+4EbdE",
  },
  enterDueDate: {
    defaultMessage: "Enter due date",
    id: "JgziY3",
  },
  dueToday: {
    defaultMessage: "Due today",
    id: "QUXFCm",
  },
  dueIn: {
    defaultMessage: "Due in {relative}",
    id: "oo/krP",
  },
  overdue: {
    defaultMessage: "{relative} overdue",
    id: "lXjJ2K",
  },
  completedOnDueDate: {
    defaultMessage: "Completed on Due Date",
    id: "aE5rlY",
  },
  completedBeforeDueDate: {
    defaultMessage: "Completed {relative} before the Due Date",
    id: "Wpk5Gj",
  },
  completedAfterDueDate: {
    defaultMessage: "Completed {relative} after the Due Date",
    id: "36ezG3",
  },
  assignTo: {
    defaultMessage: "Assign to",
    id: "6vZ988",
  },
  assignedTo: {
    defaultMessage: "Assigned to",
    id: "ONVN5F",
  },
  assignedToName: {
    defaultMessage: "Assigned to {name}",
    id: "ATvbzL",
  },
  removeAssignment: {
    defaultMessage: "Remove Assignment",
    id: "tS22VT",
  },
  search: {
    defaultMessage: "Search",
    id: "xmcVZ0",
  },
  noResults: {
    defaultMessage: "No results found",
    id: "hX5PAb",
  },
  addNewItemPlaceholder: {
    defaultMessage: "Add New Item",
    id: "4CZFEs",
  },
  assigneeMembersLabel: {
    defaultMessage: "Members",
    id: "+a+2ug",
  },
  assigneeTeamsLabel: {
    defaultMessage: "Teams",
    id: "DNeuzb",
  },
});
